import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.new.spacing.medium,
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(1.5),
    backgroundColor: theme.new.color.common.white,
    border: `1px solid ${theme.new.color.line.border}`,
    borderRadius: theme.new.shape.borderRadius.small,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.xsmall,
    width: '100%',
  },
  textfield: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      minHeight: 46,
      padding: 0,
      backgroundColor: theme.new.color.background.input,
      borderRadius: theme.new.shape.borderRadius.small,
      transition: theme.transitions.create(['box-shadow', 'border-color']),
      '&.Mui-focused': {
        boxShadow: `0 0 0 1px ${theme.new.color.common.white}, 0 0 0 2px ${theme.new.color.brand[200]}`,
      },
    },
    '& textarea': {
      ...theme.typography.small_body_regular,
      lineHeight: 1.6,
      color: theme.new.color.textPrimary,
    },
  },
  warning: {
    ...theme.typography.caption_regular,
    lineHeight: 1.4,
    color: theme.new.color.textSecondary,
    margin: 0,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.new.spacing.small,
    width: '100%',
  },
  submitButton: {
    flexShrink: 0,
    width: 28,
    height: 28,
    padding: 0,
    color: theme.new.color.common.white,
    backgroundColor: theme.new.color.brand[600],
    border: `1px solid ${theme.new.color.line.border}`,
    '&:hover': {
      backgroundColor: theme.new.color.brand[600],
    },
    '&.Mui-disabled': {
      color: theme.new.color.common.white,
      backgroundColor: theme.new.color.brand[600],
      opacity: 0.4,
    },
  },
}));

export default useStyles;
